export const reasonsError = 'Aggregator/Payer combination not found';

export const reasonListHeaders = [
  { header: 'reasonCode', label: 'REASON CODE' },
  { header: 'description', label: 'DESCRIPTION' },
  { header: 'noteRequired', label: 'NOTE REQUIRED' },
  { header: 'alertType', label: 'ALERT TYPE' },
];
